<script>
  import ListHeader from '../../../../components/list/Header.vue'

  import * as restfulService from '../../../../services/restfulService'

  import bus from '@utils/bus'

  export default {
    components: {ListHeader},
    data () {
      return {
        activeTab: 'advisors-urcamp',
        mainEventId: null,
        list: [],
        filters: {
          ref_pessoa: '',
          name: '',
          sub_event: '',
          campus: '',
          course: '',
          status: '',
          institution: ''
        }
      }
    },
    computed: {
      pageTitle: function () {
        return 'Relatórios Gerenciais'
      },
      listFiltered: function () {
        let list = this.list
        if (this.filters.ref_pessoa) {
          list = list.filter(item => item.ref_pessoa && (item.ref_pessoa).toString().includes((this.filters.ref_pessoa).toString()))
        }
        if (this.filters.name) {
          list = list.filter(item => item.nome && item.nome.toLowerCase().includes(this.filters.name.toLowerCase()))
        }
        if (this.filters.sub_event) {
          list = list.filter(item => item.subevento && item.subevento.includes(this.filters.sub_event))
        }
        if (this.filters.campus) {
          list = list.filter(item => item.campus && item.campus.includes(this.filters.campus))
        }
        if (this.filters.course) {
          list = list.filter(item => item.curso && item.curso.includes(this.filters.course))
        }
        if (this.filters.status) {
          list = list.filter(item => item.status && item.status.includes(this.filters.status))
        }
        if (this.filters.institution) {
          list = list.filter(item => item.instituicao && item.instituicao.includes(this.filters.institution))
        }
        return list
      },
      listEvents: function () {
        return [...new Set(this.list.map(item => item.subevento))].sort()
      },
      listCampus: function () {
        return [...new Set(this.list.map(item => item.campus))].sort()
      },
      listCourse: function () {
        return [...new Set(this.list.map(item => item.curso))].sort()
      },
      listStatus: function () {
        return [...new Set(this.list.map(item => item.status))].sort()
      },
      listInstitution: function () {
        return [...new Set(this.list.map(item => item.instituicao))].sort()
      }
    },
    mounted () {
      this.mainEventId = this.$route.params.id || null
      this.loadList(this.activeTab)
    },
    watch: {
      activeTab: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadList(newValue)
        }
      }
    },
    methods: {
      loadList (route) {
        bus.$emit('show-loader')
        this.list.splice(0)
        restfulService.get('event', 'reports/' + route, this.mainEventId)
          .then(response => {
            this.list = response
            bus.$emit('hide-loader')
          })
          .catch((err) => {
            console.log(err)
            bus.$emit('hide-loader')
          })
      },
      onFilterClean () {
        this.filters = {
          ref_pessoa: '',
          name: '',
          sub_event: '',
          campus: '',
          course: '',
          status: ''
        }
      }
    }
  }
</script>

<template>
    <div>
        <ListHeader :title="pageTitle" back-route="event.index"/>

        <el-card class="el-card__search_list box-card" style="margin-bottom: 30px;">
            <div slot="header">
                <span>Filtrar Listagem</span>
                <div>
                    <el-button type="default" @click="onFilterClean">Limpar todos filtros</el-button>
                </div>
            </div>
            <el-form :inline="true" :model="filters" class="demo-form-inline">
                <el-form-item label="Matrícula">
                    <el-input v-model="filters.ref_pessoa"
                              placeholder="Filtrar por Matrícula"/>
                </el-form-item>
                <el-form-item label="Nome">
                    <el-input v-model="filters.name"
                              placeholder="Filtrar por Nome"/>
                </el-form-item>
                <el-form-item label="Evento">
                    <el-select v-model="filters.sub_event"
                               clearable
                               placeholder="Filtrar por evento"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in listEvents"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Campus">
                    <el-select v-model="filters.campus"
                               clearable
                               placeholder="Filtrar por campus"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in listCampus"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Curso">
                    <el-select v-model="filters.course"
                               clearable
                               placeholder="Filtrar por curso"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in listCourse"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Status">
                    <el-select v-model="filters.status"
                               clearable
                               placeholder="Filtrar por status"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in listStatus"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Instituição">
                    <el-select v-model="filters.institution"
                               clearable
                               placeholder="Filtrar por Instituição"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in listInstitution"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </el-card>

        <el-tabs type="card" v-model="activeTab">
            <el-tab-pane name="advisors-urcamp" label="Orientadores da URCAMP">
                <table class="custom-table-list" v-if="activeTab === 'advisors-urcamp'">
                    <thead>
                    <tr>
                        <th colspan="10" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                    </tr>
                    <tr>
                        <th>Cód. Pessoa</th>
                        <th>Nome</th>
                        <th>Evento</th>
                        <th>Título Trabalho</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listFiltered">
                        <td>{{item.ref_pessoa}}</td>
                        <td>{{item.nome}}</td>
                        <td>{{item.subevento}}</td>
                        <td>{{item.titulo}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="authors-students-urcamp" label="Alunos Autores ou Coautores">
                <table class="custom-table-list" v-if="activeTab === 'authors-students-urcamp'">
                    <thead>
                    <tr>
                        <th colspan="10" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                    </tr>
                    <tr>
                        <th>Cód. Pessoa</th>
                        <th>Nome</th>
                        <th>Evento</th>
                        <th>Título Trabalho</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listFiltered">
                        <td>{{item.ref_pessoa}}</td>
                        <td>{{item.nome}}</td>
                        <td>{{item.subevento}}</td>
                        <td>{{item.titulo}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="authors-professors-urcamp" label="Professors Autores ou Coautores">
                <table class="custom-table-list" v-if="activeTab === 'authors-professors-urcamp'">
                    <thead>
                    <tr>
                        <th colspan="10" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                    </tr>
                    <tr>
                        <th>Cód. Pessoa</th>
                        <th>Nome</th>
                        <th>Evento</th>
                        <th>Título Trabalho</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listFiltered">
                        <td>{{item.ref_pessoa}}</td>
                        <td>{{item.nome}}</td>
                        <td>{{item.subevento}}</td>
                        <td>{{item.titulo}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="registrations-fies" label="Inscritos FIES">
                <table class="custom-table-list" v-if="activeTab === 'registrations-fies'">
                    <thead>
                    <tr>
                        <th colspan="10" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                    </tr>
                    <tr>
                        <th>Cód. Pessoa</th>
                        <th>Nome</th>
                        <th>Evento</th>
                        <th>Título Trabalho</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listFiltered">
                        <td>{{item.ref_pessoa}}</td>
                        <td>{{item.nome}}</td>
                        <td>{{item.subevento}}</td>
                        <td>{{item.titulo}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="registrations-prouni" label="Inscritos Prouni">
                <table class="custom-table-list" v-if="activeTab === 'registrations-prouni'">
                    <thead>
                    <tr>
                        <th colspan="10" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                    </tr>
                    <tr>
                        <th>Cód. Pessoa</th>
                        <th>Nome</th>
                        <th>Evento</th>
                        <th>Título Trabalho</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listFiltered">
                        <td>{{item.ref_pessoa}}</td>
                        <td>{{item.nome}}</td>
                        <td>{{item.subevento}}</td>
                        <td>{{item.titulo}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="registrations-course-campus" label="Inscritos por Curso e Campus">
                <table class="custom-table-list" v-if="activeTab === 'registrations-course-campus'">
                    <thead>
                    <tr>
                        <th colspan="10" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                    </tr>
                    <tr>
                        <th>Campus</th>
                        <th>Curso</th>
                        <th>Cód. Pessoa</th>
                        <th>Nome</th>
                        <th>Status Inscrição</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listFiltered">
                        <td>{{item.campus}}</td>
                        <td>{{item.curso}}</td>
                        <td>{{item.ref_pessoa}}</td>
                        <td>{{item.nome}}</td>
                        <td>{{item.status}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="submissions" label="Trabalhos">
                <div v-if="activeTab === 'submissions'">
                    <table class="custom-table-list">
                        <thead>
                        <tr>
                            <th colspan="10" style="font-size: 16px">Estatísticas da Triagem</th>
                        </tr>
                        <tr>
                            <th>Evento</th>
                            <th>Não Atribuídos</th>
                            <th>Aprovados</th>
                            <th>Reprovados</th>
                            <th>Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in listFiltered">
                            <td>{{item.subevent}}</td>
                            <td>{{item.nao_designado}}</td>
                            <td>{{item.aprovado_pela_triagem}}</td>
                            <td>{{item.reprovado_pela_triagem}}</td>
                            <td>{{item.nao_designado + item.aprovado_pela_triagem + item.reprovado_pela_triagem}}</td>
                        </tr>
                        </tbody>
                        <thead>
                        <tr>
                            <th colspan="10" style="font-size: 16px">Estatísticas da Avaliação</th>
                        </tr>
                        <tr>
                            <th>Evento</th>
                            <th>Em Avaliação</th>
                            <th>Aprovados</th>
                            <th>Reprovados</th>
                            <th>Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in listFiltered">
                            <td>{{item.subevent}}</td>
                            <td>{{item.em_avaliacao}}</td>
                            <td>{{item.avaliado}}</td>
                            <td>{{item.reprovado}}</td>
                            <td>{{item.em_avaliacao + item.avaliado + item.reprovado}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane name="submissions-event-area-city" label="Trabalhos por Evento, Área, Cidade">
                <table class="custom-table-list" v-if="activeTab === 'submissions-event-area-city'">
                    <thead>
                    <tr>
                        <th colspan="10" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                    </tr>
                    <tr>
                        <th>Evento</th>
                        <th>Área</th>
                        <th>Cidade</th>
                        <th>Título</th>
                        <th>Autor</th>
                        <th>E-mail</th>
                        <th>Instituição</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listFiltered">
                        <td>{{item.subevento}}</td>
                        <td>{{item.area_conhecimento}}</td>
                        <td>{{item.cidade}}</td>
                        <td>{{item.titulo}}</td>
                        <td>{{item.nome}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.instituicao}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="event-participants" label="Participantes do Evento">
                <table class="custom-table-list" v-if="activeTab === 'event-participants'">
                    <thead>
                    <tr>
                        <th colspan="10" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                    </tr>
                    <tr>
                        <th>Inscrição Nº</th>
                        <th>Id</th>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th>CPF</th>
                        <th>Cidade/Estado</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listFiltered">
                        <td>{{item.registration}}</td>
                        <td>{{item.id}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.social_number}}</td>
                        <td>{{item.city}}/{{item.state}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>



// WEBPACK FOOTER //
// ReportsAdmin.vue?cb6728fa